import React from 'react';

type IconProps = {
  color?: string;
  size?: string;
};

export const EditTabLogo = ({ color, size }: IconProps) => (
  <svg
    width={size ?? '20'}
    height={size ?? '20'}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_458_1927)">
      <path
        d="M0.857422 23.1426H19.7146"
        stroke={color}
        strokeWidth="1.71429"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.1429 17.1433L6 18.069L6.85714 12.8576L18.3943 1.35474C18.5537 1.19406 18.7433 1.06653 18.9522 0.979497C19.1611 0.892465 19.3851 0.847656 19.6114 0.847656C19.8377 0.847656 20.0618 0.892465 20.2707 0.979497C20.4796 1.06653 20.6692 1.19406 20.8286 1.35474L22.6457 3.17188C22.8064 3.33125 22.9339 3.52085 23.021 3.72975C23.108 3.93865 23.1528 4.16272 23.1528 4.38902C23.1528 4.61533 23.108 4.8394 23.021 5.0483C22.9339 5.2572 22.8064 5.4468 22.6457 5.60617L11.1429 17.1433Z"
        stroke={color}
        strokeWidth="1.71429"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_458_1927">
        <rect width="24" height="24" fill={color} />
      </clipPath>
    </defs>
  </svg>
);

export const PlaygroundTabLogo = ({ color }: IconProps) => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 5.5C11.7348 5.5 11.4804 5.60536 11.2929 5.79289C11.1054 5.98043 11 6.23478 11 6.5C11 6.76522 11.1054 7.01957 11.2929 7.20711C11.4804 7.39464 11.7348 7.5 12 7.5C12.2652 7.5 12.5196 7.39464 12.7071 7.20711C12.8946 7.01957 13 6.76522 13 6.5C13 6.23478 12.8946 5.98043 12.7071 5.79289C12.5196 5.60536 12.2652 5.5 12 5.5ZM7 6.5C7 6.23478 7.10536 5.98043 7.29289 5.79289C7.48043 5.60536 7.73478 5.5 8 5.5C8.26522 5.5 8.51957 5.60536 8.70711 5.79289C8.89464 5.98043 9 6.23478 9 6.5C9 6.76522 8.89464 7.01957 8.70711 7.20711C8.51957 7.39464 8.26522 7.5 8 7.5C7.73478 7.5 7.48043 7.39464 7.29289 7.20711C7.10536 7.01957 7 6.76522 7 6.5ZM10.5 2.5C10.5 2.36739 10.4473 2.24021 10.3536 2.14645C10.2598 2.05268 10.1326 2 10 2C9.86739 2 9.74021 2.05268 9.64645 2.14645C9.55268 2.24021 9.5 2.36739 9.5 2.5V3H6.5C6.10218 3 5.72064 3.15804 5.43934 3.43934C5.15804 3.72064 5 4.10218 5 4.5V8.5C5 8.89782 5.15804 9.27936 5.43934 9.56066C5.72064 9.84196 6.10218 10 6.5 10H13.5C13.8978 10 14.2794 9.84196 14.5607 9.56066C14.842 9.27936 15 8.89782 15 8.5V4.5C15 4.10218 14.842 3.72064 14.5607 3.43934C14.2794 3.15804 13.8978 3 13.5 3H10.5V2.5ZM6.5 4H13.5C13.6326 4 13.7598 4.05268 13.8536 4.14645C13.9473 4.24021 14 4.36739 14 4.5V8.5C14 8.63261 13.9473 8.75979 13.8536 8.85355C13.7598 8.94732 13.6326 9 13.5 9H6.5C6.36739 9 6.24021 8.94732 6.14645 8.85355C6.05268 8.75979 6 8.63261 6 8.5V4.5C6 4.36739 6.05268 4.24021 6.14645 4.14645C6.24021 4.05268 6.36739 4 6.5 4ZM10.25 17.998C12.866 17.965 14.445 17.403 15.372 16.558C16.247 15.758 16.461 14.781 16.495 14.002H16.5V13.312C16.4997 12.8321 16.3089 12.372 15.9695 12.0328C15.6301 11.6936 15.1699 11.503 14.69 11.503H11.5V11.5H8.5V11.503H5.31C4.31 11.503 3.5 12.313 3.5 13.313V14.002H3.505C3.539 14.782 3.753 15.759 4.628 16.557C5.555 17.403 7.134 17.965 9.75 17.998V18H10.25V17.998ZM5.31 12.503H14.69C14.9048 12.503 15.1109 12.5883 15.2628 12.7402C15.4147 12.8921 15.5 13.0982 15.5 13.313V13.75C15.5 14.44 15.369 15.206 14.698 15.819C14.01 16.446 12.66 17 10 17C7.34 17 5.99 16.446 5.302 15.819C4.632 15.206 4.5 14.439 4.5 13.75V13.312C4.50027 13.0973 4.58572 12.8916 4.7376 12.7399C4.88947 12.5882 5.09535 12.503 5.31 12.503Z"
      fill={color}
      strokeWidth={'0.05'}
    />
  </svg>
);

export const ClientManagementLogo = ({ color }: IconProps) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      strokeWidth="0.01"
      d="M10 12C8.9 12 7.95833 11.6083 7.175 10.825C6.39167 10.0417 6 9.1 6 8C6 6.9 6.39167 5.95833 7.175 5.175C7.95833 4.39167 8.9 4 10 4C11.1 4 12.0417 4.39167 12.825 5.175C13.6083 5.95833 14 6.9 14 8C14 9.1 13.6083 10.0417 12.825 10.825C12.0417 11.6083 11.1 12 10 12ZM2 18V17.2C2 16.65 2.14167 16.1333 2.425 15.65C2.70833 15.1667 3.1 14.8 3.6 14.55C4.56667 14.0667 5.56667 13.6873 6.6 13.412C7.63333 13.1367 8.69167 12.9993 9.775 13C10.0583 13 10.296 13.1 10.488 13.3C10.68 13.5 10.7757 13.7417 10.775 14.025C10.7743 14.3083 10.6783 14.546 10.487 14.738C10.2957 14.93 10.0583 15.0257 9.775 15.025C8.84167 15.025 7.93733 15.1417 7.062 15.375C6.18667 15.6083 5.33267 15.9333 4.5 16.35C4.33333 16.4333 4.20833 16.55 4.125 16.7C4.04167 16.85 4 17.0167 4 17.2V18H9.775C10.0583 18 10.296 18.096 10.488 18.288C10.68 18.48 10.7757 18.7173 10.775 19C10.7743 19.2827 10.6783 19.5203 10.487 19.713C10.2957 19.9057 10.0583 20.0013 9.775 20H4C3.45 20 2.97933 19.8043 2.588 19.413C2.19667 19.0217 2.00067 18.5507 2 18ZM15.85 20.2L15.7 19.5C15.5 19.4167 15.3127 19.3293 15.138 19.238C14.9633 19.1467 14.784 19.034 14.6 18.9L13.875 19.125C13.6583 19.1917 13.446 19.1833 13.238 19.1C13.03 19.0167 12.8673 18.8833 12.75 18.7L12.55 18.35C12.4333 18.15 12.3917 17.9333 12.425 17.7C12.4583 17.4667 12.5667 17.275 12.75 17.125L13.3 16.65C13.2667 16.4167 13.25 16.2 13.25 16C13.25 15.8 13.2667 15.5833 13.3 15.35L12.75 14.875C12.5667 14.725 12.4583 14.5373 12.425 14.312C12.3917 14.0867 12.4333 13.8743 12.55 13.675L12.775 13.3C12.8917 13.1167 13.05 12.9833 13.25 12.9C13.45 12.8167 13.6583 12.8083 13.875 12.875L14.6 13.1C14.7833 12.9667 14.9627 12.854 15.138 12.762C15.3133 12.67 15.5007 12.5827 15.7 12.5L15.85 11.775C15.9 11.5417 16.0127 11.3543 16.188 11.213C16.3633 11.0717 16.5673 11.0007 16.8 11H17.2C17.4333 11 17.6377 11.075 17.813 11.225C17.9883 11.375 18.1007 11.5667 18.15 11.8L18.3 12.5C18.5 12.5833 18.6873 12.675 18.862 12.775C19.0367 12.875 19.216 13 19.4 13.15L20.075 12.925C20.3083 12.8417 20.5333 12.8417 20.75 12.925C20.9667 13.0083 21.1333 13.15 21.25 13.35L21.45 13.7C21.5667 13.9 21.6083 14.1167 21.575 14.35C21.5417 14.5833 21.4333 14.775 21.25 14.925L20.7 15.4C20.7333 15.6 20.75 15.8083 20.75 16.025C20.75 16.2417 20.7333 16.45 20.7 16.65L21.25 17.125C21.4333 17.275 21.5417 17.4627 21.575 17.688C21.6083 17.9133 21.5667 18.1257 21.45 18.325L21.225 18.7C21.1083 18.8833 20.95 19.0167 20.75 19.1C20.55 19.1833 20.3417 19.1917 20.125 19.125L19.4 18.9C19.2167 19.0333 19.0373 19.1457 18.862 19.237C18.6867 19.3283 18.4993 19.416 18.3 19.5L18.15 20.225C18.1 20.4583 17.9877 20.646 17.813 20.788C17.6383 20.93 17.434 21.0007 17.2 21H16.8C16.5667 21 16.3627 20.925 16.188 20.775C16.0133 20.625 15.9007 20.4333 15.85 20.2ZM17 18C17.55 18 18.021 17.8043 18.413 17.413C18.805 17.0217 19.0007 16.5507 19 16C18.9993 15.4493 18.8037 14.9787 18.413 14.588C18.0223 14.1973 17.5513 14.0013 17 14C16.4487 13.9987 15.978 14.1947 15.588 14.588C15.198 14.9813 15.002 15.452 15 16C14.998 16.548 15.194 17.019 15.588 17.413C15.982 17.807 16.4527 18.0027 17 18ZM10 10C10.55 10 11.021 9.80433 11.413 9.413C11.805 9.02167 12.0007 8.55067 12 8C11.9993 7.44933 11.8037 6.97867 11.413 6.588C11.0223 6.19733 10.5513 6.00133 10 6C9.44867 5.99867 8.978 6.19467 8.588 6.588C8.198 6.98133 8.002 7.452 8 8C7.998 8.548 8.194 9.019 8.588 9.413C8.982 9.807 9.45267 10.0027 10 10Z"
      fill={color}
    />
  </svg>
);

export const MyUsageLogo = ({ color, size = 24 }: any) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M21.2536 14.1141C21.11 14.7119 20.4104 15.0299 19.833 14.736L19.8295 14.7325L19.7761 14.7006C19.4034 14.4783 19.2219 14.0421 19.3179 13.5991C19.4355 13.0853 19.5 12.5586 19.5 12C19.5 8.63437 17.2812 5.79644 14.2301 4.84311C13.7894 4.70271 13.5 4.3225 13.5 3.89003V3.87003C13.5 3.19833 14.1526 2.71854 14.774 2.90824L14.7742 2.90829C18.6692 4.09582 21.5 7.7257 21.5 12C21.5 12.7203 21.4147 13.4314 21.2536 14.1141ZM9.76767 4.8407L9.76766 4.84066L9.76117 4.84268C8.04486 5.37769 6.57798 6.51171 5.628 8.03798C4.67838 9.56366 4.30848 11.3797 4.58565 13.1552C5.05865 16.352 7.65925 18.9527 10.8673 19.4147C13.2403 19.7672 15.4288 19.0073 17.0055 17.5707C17.3617 17.251 17.8456 17.1936 18.2171 17.4114L18.2208 17.4135C18.795 17.7435 18.8852 18.5483 18.3917 19.0018C16.4072 20.8249 13.6543 21.804 10.6667 21.4045C6.50989 20.8446 3.14543 17.4801 2.5855 13.3233L2.58519 13.321C2.2731 11.0805 2.76911 8.80194 3.98432 6.89382C5.19929 4.98606 7.0538 3.57322 9.21563 2.90834C9.85035 2.71737 10.5 3.20161 10.5 3.87003V3.89003C10.5 4.32628 10.2076 4.71009 9.76767 4.8407Z"
      stroke={color}
    />
  </svg>
);

export const ClientsUsageLogo = ({ color }: IconProps) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6 13.5H9V15H6V13.5ZM10.5 13.5H13.5V15H10.5V13.5ZM6 10.5H9V12H6V10.5ZM10.5 16.5H13.5V18H10.5V16.5ZM15 10.5H18V12H15V10.5ZM15 16.5H18V18H15V16.5Z"
      fill={color}
      strokeWidth="0.25"
    />
    <path
      d="M20.25 2.25H3.75C3.35236 2.2506 2.97117 2.40882 2.69 2.69C2.40882 2.97117 2.2506 3.35236 2.25 3.75V20.25C2.2506 20.6476 2.40882 21.0288 2.69 21.31C2.97117 21.5912 3.35236 21.7494 3.75 21.75H20.25C20.6476 21.7494 21.0288 21.5912 21.31 21.31C21.5912 21.0288 21.7494 20.6476 21.75 20.25V3.75C21.7494 3.35236 21.5912 2.97117 21.31 2.69C21.0288 2.40882 20.6476 2.2506 20.25 2.25ZM20.25 3.75V6.75H3.75V3.75H20.25ZM3.75 20.25V8.25H20.25V20.25H3.75Z"
      fill={color}
      strokeWidth="0.25"
    />
  </svg>
);

export const UploadTabLogo = ({ color, size }: IconProps) => (
  <svg
    width={size ?? '26'}
    height={size ?? '26'}
    viewBox="0 0 26 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.0004 18.9996V10.5996M13.0004 10.5996L16.6004 14.1996M13.0004 10.5996L9.40039 14.1996"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17.7992 7H8.19922"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M1 13C1 7.3432 1 4.5148 2.7568 2.7568C4.516 1 7.3432 1 13 1C18.6568 1 21.4852 1 23.242 2.7568C25 4.516 25 7.3432 25 13C25 18.6568 25 21.4852 23.242 23.242C21.4864 25 18.6568 25 13 25C7.3432 25 4.5148 25 2.7568 23.242C1 21.4864 1 18.6568 1 13Z"
      stroke={color}
      strokeWidth="1.5"
    />
  </svg>
);

export const ContentAnalysisTabLogo = ({ color }: IconProps) => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7 8H12V10H7V8ZM7 12H12V14H7V12ZM7 16H12V18H7V16ZM20 8H25V10H20V8ZM20 12H25V14H20V12ZM20 16H25V18H20V16Z"
      fill={color}
      strokeWidth="0.25"
    />
    <path
      d="M28 4H4C3.46973 4.00053 2.96133 4.21141 2.58637 4.58637C2.21141 4.96133 2.00053 5.46973 2 6V28C2.00053 28.5303 2.21141 29.0387 2.58637 29.4136C2.96133 29.7886 3.46973 29.9995 4 30H28C28.5303 29.9995 29.0387 29.7886 29.4136 29.4136C29.7886 29.0387 29.9995 28.5303 30 28V6C29.9995 5.46973 29.7886 4.96133 29.4136 4.58637C29.0387 4.21141 28.5303 4.00053 28 4ZM4 6H15V28H4V6ZM17 28V6H28V28H17Z"
      fill={color}
      strokeWidth="0.25"
    />
  </svg>
);

export const DashboardTabLogo = ({ color }: IconProps) => (
  <svg
    width="28"
    height="28"
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    strokeWidth="0.15"
  >
    <path
      d="M6.75 3C5.75544 3 4.80161 3.39509 4.09835 4.09835C3.39509 4.80161 3 5.75544 3 6.75V21.25C3 22.2446 3.39509 23.1984 4.09835 23.9017C4.80161 24.6049 5.75544 25 6.75 25H21.25C22.2446 25 23.1984 24.6049 23.9017 23.9017C24.6049 23.1984 25 22.2446 25 21.25V6.75C25 5.75544 24.6049 4.80161 23.9017 4.09835C23.1984 3.39509 22.2446 3 21.25 3H6.75ZM4.5 6.75C4.5 6.15326 4.73705 5.58097 5.15901 5.15901C5.58097 4.73705 6.15326 4.5 6.75 4.5H21.25C21.8467 4.5 22.419 4.73705 22.841 5.15901C23.2629 5.58097 23.5 6.15326 23.5 6.75V21.25C23.5 21.8467 23.2629 22.419 22.841 22.841C22.419 23.2629 21.8467 23.5 21.25 23.5H6.75C6.15326 23.5 5.58097 23.2629 5.15901 22.841C4.73705 22.419 4.5 21.8467 4.5 21.25V6.75ZM6 9C6 8.46957 6.21071 7.96086 6.58579 7.58579C6.96086 7.21071 7.46957 7 8 7H20C20.5304 7 21.0391 7.21071 21.4142 7.58579C21.7893 7.96086 22 8.46957 22 9V11C22 11.5304 21.7893 12.0391 21.4142 12.4142C21.0391 12.7893 20.5304 13 20 13H8C7.46957 13 6.96086 12.7893 6.58579 12.4142C6.21071 12.0391 6 11.5304 6 11V9ZM8 8.5C7.86739 8.5 7.74021 8.55268 7.64645 8.64645C7.55268 8.74021 7.5 8.86739 7.5 9V11C7.5 11.1326 7.55268 11.2598 7.64645 11.3536C7.74021 11.4473 7.86739 11.5 8 11.5H20C20.1326 11.5 20.2598 11.4473 20.3536 11.3536C20.4473 11.2598 20.5 11.1326 20.5 11V9C20.5 8.86739 20.4473 8.74021 20.3536 8.64645C20.2598 8.55268 20.1326 8.5 20 8.5H8ZM6 15.75C6 15.5511 6.07902 15.3603 6.21967 15.2197C6.36032 15.079 6.55109 15 6.75 15H12.25C12.4489 15 12.6397 15.079 12.7803 15.2197C12.921 15.3603 13 15.5511 13 15.75C13 15.9489 12.921 16.1397 12.7803 16.2803C12.6397 16.421 12.4489 16.5 12.25 16.5H6.75C6.55109 16.5 6.36032 16.421 6.21967 16.2803C6.07902 16.1397 6 15.9489 6 15.75ZM6.75 18.75C6.55109 18.75 6.36032 18.829 6.21967 18.9697C6.07902 19.1103 6 19.3011 6 19.5C6 19.6989 6.07902 19.8897 6.21967 20.0303C6.36032 20.171 6.55109 20.25 6.75 20.25H12.25C12.4489 20.25 12.6397 20.171 12.7803 20.0303C12.921 19.8897 13 19.6989 13 19.5C13 19.3011 12.921 19.1103 12.7803 18.9697C12.6397 18.829 12.4489 18.75 12.25 18.75H6.75ZM15.5 16.25C15.5 15.284 16.284 14.5 17.25 14.5H20.25C21.216 14.5 22 15.284 22 16.25V19.25C22 19.7141 21.8156 20.1592 21.4874 20.4874C21.1592 20.8156 20.7141 21 20.25 21H17.25C16.7859 21 16.3408 20.8156 16.0126 20.4874C15.6844 20.1592 15.5 19.7141 15.5 19.25V16.25ZM17.25 16C17.1837 16 17.1201 16.0263 17.0732 16.0732C17.0263 16.1201 17 16.1837 17 16.25V19.25C17 19.388 17.112 19.5 17.25 19.5H20.25C20.3163 19.5 20.3799 19.4737 20.4268 19.4268C20.4737 19.3799 20.5 19.3163 20.5 19.25V16.25C20.5 16.1837 20.4737 16.1201 20.4268 16.0732C20.3799 16.0263 20.3163 16 20.25 16H17.25Z"
      fill={color}
    />
  </svg>
);

export const DownLogo = ({ color }: IconProps) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2 11L11.4615 20.7592C11.5306 20.8352 11.614 20.8958 11.7066 20.9372C11.7992 20.9786 11.8991 21 12 21C12.1009 21 12.2008 20.9786 12.2934 20.9372C12.386 20.8958 12.4694 20.8352 12.5385 20.7592L22 11"
      stroke={color}
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2 3L11.4615 12.7729C11.6053 12.9185 11.7987 13 12 13C12.2013 13 12.3947 12.9185 12.5385 12.7729L22 3"
      stroke={color}
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ThemeTabLogo = ({ color }: IconProps) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.5717 8.57115C15.5185 8.57115 16.286 7.80364 16.286 6.85686C16.286 5.91009 15.5185 5.14258 14.5717 5.14258C13.6249 5.14258 12.8574 5.91009 12.8574 6.85686C12.8574 7.80364 13.6249 8.57115 14.5717 8.57115Z"
      stroke={color}
      strokeWidth="1.71429"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.71456 17.144C8.18795 17.144 8.57171 16.7602 8.57171 16.2868C8.57171 15.8134 8.18795 15.4297 7.71456 15.4297C7.24118 15.4297 6.85742 15.8134 6.85742 16.2868C6.85742 16.7602 7.24118 17.144 7.71456 17.144Z"
      stroke={color}
      strokeWidth="1.71429"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.71429 11.1434C8.66106 11.1434 9.42857 10.3759 9.42857 9.42913C9.42857 8.48236 8.66106 7.71484 7.71429 7.71484C6.76751 7.71484 6 8.48236 6 9.42913C6 10.3759 6.76751 11.1434 7.71429 11.1434Z"
      stroke={color}
      strokeWidth="1.71429"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.32 21.0517C16.3009 20.7192 16.1853 20.3994 15.9874 20.1315C15.7895 19.8636 15.5179 19.6592 15.2057 19.5431C14.4303 19.2883 13.7713 18.7652 13.3471 18.0679C12.9229 17.3707 12.7614 16.5449 12.8915 15.7392C13.0217 14.9335 13.435 14.2006 14.0571 13.6724C14.6793 13.1441 15.4695 12.8552 16.2857 12.8574H19.4914C20.0412 12.859 20.5833 12.7282 21.072 12.4763C21.5607 12.2243 21.9817 11.8585 22.2993 11.4098C22.617 10.961 22.8221 10.4424 22.8973 9.89775C22.9725 9.35309 22.9156 8.79834 22.7314 8.28028C22.0495 6.35509 20.8517 4.65432 19.2687 3.36379C17.6857 2.07326 15.7785 1.24263 13.7554 0.962635C11.7323 0.682641 9.67121 0.964059 7.79722 1.77614C5.92324 2.58823 4.3085 3.89974 3.12941 5.56738C1.95033 7.23503 1.25226 9.19466 1.11147 11.2322C0.970684 13.2697 1.3926 15.3067 2.33111 17.1207C3.26963 18.9346 4.68864 20.4558 6.43312 21.5179C8.1776 22.58 10.1804 23.1422 12.2228 23.1431C13.2314 23.146 14.2355 23.0075 15.2057 22.7317C15.562 22.6319 15.8706 22.4073 16.0751 22.0989C16.2797 21.7905 16.3666 21.4188 16.32 21.0517V21.0517Z"
      stroke={color}
      strokeWidth="1.71429"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const PreviewTabLogo = ({ color }: IconProps) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M22.6796 10.8511C22.9639 11.1662 23.1213 11.5754 23.1213 11.9997C23.1213 12.424 22.9639 12.8333 22.6796 13.1483C20.8796 15.0854 16.7825 18.8569 11.9996 18.8569C7.21674 18.8569 3.1196 15.0854 1.3196 13.1483C1.0353 12.8333 0.87793 12.424 0.87793 11.9997C0.87793 11.5754 1.0353 11.1662 1.3196 10.8511C3.1196 8.91401 7.21674 5.14258 11.9996 5.14258C16.7825 5.14258 20.8796 8.91401 22.6796 10.8511Z"
      stroke={color}
      strokeWidth="1.71429"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.9999 15.4275C13.8934 15.4275 15.4284 13.8924 15.4284 11.9989C15.4284 10.1053 13.8934 8.57031 11.9999 8.57031C10.1063 8.57031 8.57129 10.1053 8.57129 11.9989C8.57129 13.8924 10.1063 15.4275 11.9999 15.4275Z"
      stroke={color}
      strokeWidth="1.71429"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const UserManagementTabLogo = ({ color }: IconProps) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.57199 8.57171C10.7022 8.57171 12.4291 6.84481 12.4291 4.71456C12.4291 2.58432 10.7022 0.857422 8.57199 0.857422C6.44175 0.857422 4.71484 2.58432 4.71484 4.71456C4.71484 6.84481 6.44175 8.57171 8.57199 8.57171Z"
      stroke={color}
      strokeWidth="1.71429"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.71456 21.4291H0.857422V18.8577C0.871069 17.5511 1.21567 16.2692 1.85903 15.1319C2.5024 13.9945 3.42354 13.0388 4.53641 12.3539C5.64928 11.6691 6.91757 11.2775 8.22282 11.2157C9.52807 11.1539 10.8277 11.4239 12.0003 12.0006"
      stroke={color}
      strokeWidth="1.71429"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18 12.8574V23.1431"
      stroke={color}
      strokeWidth="1.71429"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.8574 18H23.1431"
      stroke={color}
      strokeWidth="1.71429"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const VisualizeLogicTabLogo = ({ color }: IconProps) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18.75 6.00001C19.0454 6.00001 19.338 6.05821 19.611 6.17128C19.884 6.28435 20.132 6.45009 20.341 6.65902C20.5499 6.86795 20.7156 7.11599 20.8287 7.38897C20.9418 7.66195 21 7.95453 21 8.25001C21 8.54548 20.9418 8.83806 20.8287 9.11105C20.7156 9.38403 20.5499 9.63207 20.341 9.841C20.132 10.0499 19.884 10.2157 19.611 10.3287C19.338 10.4418 19.0454 10.5 18.75 10.5C18.1532 10.5 17.5809 10.263 17.159 9.841C16.737 9.41904 16.5 8.84675 16.5 8.25001C16.5 7.65327 16.737 7.08098 17.159 6.65902C17.5809 6.23706 18.1532 6.00001 18.75 6.00001ZM15.075 9.00001C15.2608 9.91054 15.7782 10.7196 16.5267 11.2704C17.2752 11.8212 18.2015 12.0744 19.1261 11.981C20.0507 11.8876 20.9077 11.4542 21.5309 10.7649C22.1541 10.0755 22.4992 9.17932 22.4992 8.25001C22.4992 7.3207 22.1541 6.4245 21.5309 5.73514C20.9077 5.04579 20.0507 4.6124 19.1261 4.519C18.2015 4.42559 17.2752 4.67883 16.5267 5.22961C15.7782 5.78039 15.2608 6.58948 15.075 7.50001H14.25C13.4543 7.50001 12.6913 7.81608 12.1286 8.37869C11.566 8.9413 11.25 9.70436 11.25 10.5V13.5C11.25 13.8978 11.0919 14.2794 10.8106 14.5607C10.5293 14.842 10.1478 15 9.74997 15H8.92497C8.7391 14.0895 8.22178 13.2804 7.47327 12.7296C6.72477 12.1788 5.79843 11.9256 4.87382 12.019C3.94922 12.1124 3.09224 12.5458 2.46901 13.2351C1.84579 13.9245 1.50073 14.8207 1.50073 15.75C1.50073 16.6793 1.84579 17.5755 2.46901 18.2649C3.09224 18.9542 3.94922 19.3876 4.87382 19.481C5.79843 19.5744 6.72477 19.3212 7.47327 18.7704C8.22178 18.2196 8.7391 17.4105 8.92497 16.5H9.74997C10.5456 16.5 11.3087 16.1839 11.8713 15.6213C12.4339 15.0587 12.75 14.2957 12.75 13.5V10.5C12.75 10.1022 12.908 9.72065 13.1893 9.43935C13.4706 9.15804 13.8521 9.00001 14.25 9.00001H15.075ZM7.49997 15.75C7.49997 16.0455 7.44177 16.3381 7.3287 16.611C7.21562 16.884 7.04989 17.1321 6.84096 17.341C6.63203 17.5499 6.38399 17.7157 6.111 17.8287C5.83802 17.9418 5.54544 18 5.24997 18C4.95449 18 4.66191 17.9418 4.38893 17.8287C4.11595 17.7157 3.86791 17.5499 3.65898 17.341C3.45004 17.1321 3.28431 16.884 3.17124 16.611C3.05817 16.3381 2.99997 16.0455 2.99997 15.75C2.99997 15.1533 3.23702 14.581 3.65898 14.159C4.08093 13.7371 4.65323 13.5 5.24997 13.5C5.8467 13.5 6.419 13.7371 6.84096 14.159C7.26291 14.581 7.49997 15.1533 7.49997 15.75Z"
      fill={color}
    />
  </svg>
);

export const UserShareLogo = ({ color }: IconProps) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_1632_1181)">
      <path
        d="M4.71456 15.8569C6.84481 15.8569 8.57171 14.13 8.57171 11.9997C8.57171 9.86948 6.84481 8.14258 4.71456 8.14258C2.58432 8.14258 0.857422 9.86948 0.857422 11.9997C0.857422 14.13 2.58432 15.8569 4.71456 15.8569Z"
        stroke={color}
        strokeWidth="1.71429"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.2859 23.144C21.4161 23.144 23.143 21.4171 23.143 19.2868C23.143 17.1566 21.4161 15.4297 19.2859 15.4297C17.1556 15.4297 15.4287 17.1566 15.4287 19.2868C15.4287 21.4171 17.1556 23.144 19.2859 23.144Z"
        stroke={color}
        strokeWidth="1.71429"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.2859 8.57171C21.4161 8.57171 23.143 6.84481 23.143 4.71456C23.143 2.58432 21.4161 0.857422 19.2859 0.857422C17.1556 0.857422 15.4287 2.58432 15.4287 4.71456C15.4287 6.84481 17.1556 8.57171 19.2859 8.57171Z"
        stroke={color}
        strokeWidth="1.71429"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.16016 10.2868L15.8402 6.42969"
        stroke={color}
        strokeWidth="1.71429"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.16016 13.7148L15.8402 17.572"
        stroke={color}
        strokeWidth="1.71429"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_1632_1181">
        <rect width="24" height="24" fill={color} />
      </clipPath>
    </defs>
  </svg>
);

export const ReportingLogo = ({ color }: IconProps) => (
  <svg
    width="56"
    height="56"
    viewBox="0 0 56 56"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M42 36.75H45.5V45.5H42V36.75ZM35 28H38.5V45.5H35V28ZM19.25 45.5C16.9302 45.4972 14.7062 44.5745 13.0659 42.9341C11.4255 41.2938 10.5028 39.0698 10.5 36.75H14C14 37.7884 14.3079 38.8034 14.8848 39.6667C15.4617 40.5301 16.2816 41.203 17.2409 41.6004C18.2002 41.9977 19.2558 42.1017 20.2742 41.8991C21.2926 41.6966 22.2281 41.1965 22.9623 40.4623C23.6965 39.7281 24.1966 38.7926 24.3991 37.7742C24.6017 36.7558 24.4977 35.7002 24.1004 34.7409C23.703 33.7816 23.0301 32.9617 22.1667 32.3848C21.3034 31.8079 20.2884 31.5 19.25 31.5V28C21.5706 28 23.7962 28.9219 25.4372 30.5628C27.0781 32.2038 28 34.4294 28 36.75C28 39.0706 27.0781 41.2962 25.4372 42.9372C23.7962 44.5781 21.5706 45.5 19.25 45.5Z"
      fill={color}
    />
    <path
      d="M49 3.5H7C6.07203 3.50093 5.18233 3.86997 4.52615 4.52615C3.86997 5.18233 3.50093 6.07203 3.5 7V49C3.50093 49.928 3.86997 50.8177 4.52615 51.4739C5.18233 52.13 6.07203 52.4991 7 52.5H49C49.9278 52.4986 50.8173 52.1294 51.4733 51.4733C52.1294 50.8173 52.4986 49.9278 52.5 49V7C52.4991 6.07203 52.13 5.18233 51.4739 4.52615C50.8177 3.86997 49.928 3.50093 49 3.5ZM49 19.25H24.5V7H49V19.25ZM21 7V19.25H7V7H21ZM7 49V22.75H49L49.0035 49H7Z"
      fill={color}
    />
  </svg>
);

export const AddThemeLogo = ({ color }: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="42"
    height="42"
    viewBox="0 0 32 32"
    fill="none"
  >
    <path
      d="M5.33334 18.6667H16"
      stroke="#242424"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M5.33334 24.6667H16"
      stroke="#242424"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M5.33334 12.6667H26.6667"
      stroke="#242424"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M5.33334 6.66675H26.6667"
      stroke="#242424"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M20 22H26.6667"
      stroke="#242424"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M23.3333 18.6667V25.3334"
      stroke="#242424"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const NERLogo = ({ color = '#242424' }: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="36"
    height="36"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M4.72787 16.137C3.18287 14.591 2.40987 13.819 2.12287 12.816C1.83487 11.813 2.08087 10.748 2.57287 8.619L2.85587 7.391C3.26887 5.599 3.47587 4.703 4.08887 4.089C4.70287 3.476 5.59887 3.269 7.39087 2.856L8.61887 2.572C10.7489 2.081 11.8129 1.835 12.8159 2.122C13.8189 2.41 14.5909 3.183 16.1359 4.728L17.9659 6.558C20.6569 9.248 21.9999 10.592 21.9999 12.262C21.9999 13.933 20.6559 15.277 17.9669 17.966C15.2769 20.656 13.9329 22 12.2619 22C10.5919 22 9.24687 20.656 6.55787 17.967L4.72787 16.137Z"
      stroke="#242424"
      stroke-width="1.5"
    />
    <path
      d="M10.021 10.2931C10.802 9.51207 10.802 8.24574 10.021 7.46469C9.23991 6.68364 7.97358 6.68364 7.19253 7.46469C6.41149 8.24574 6.41148 9.51207 7.19253 10.2931C7.97358 11.0742 9.23991 11.0742 10.021 10.2931Z"
      stroke="#242424"
      stroke-width="1.5"
    />
    <path
      d="M11.542 18.5L18.521 11.52"
      className="hover:border-link-blue"
      stroke={color}
      stroke-width="1.5"
      stroke-linecap="round"
    />
  </svg>
);

export const AutoThemeAction = ({ color = '#242424' }: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="52"
    height="52"
    viewBox="0 0 52 52"
    fill="none"
  >
    <g clip-path="url(#clip0_9004_3577)">
      <path
        d="M31.1996 14.3C30.51 14.3 29.8487 14.5739 29.3611 15.0615C28.8735 15.5491 28.5996 16.2104 28.5996 16.9C28.5996 17.5895 28.8735 18.2508 29.3611 18.7384C29.8487 19.226 30.51 19.5 31.1996 19.5C31.8892 19.5 32.5505 19.226 33.0381 18.7384C33.5257 18.2508 33.7996 17.5895 33.7996 16.9C33.7996 16.2104 33.5257 15.5491 33.0381 15.0615C32.5505 14.5739 31.8892 14.3 31.1996 14.3ZM18.1996 16.9C18.1996 16.2104 18.4735 15.5491 18.9611 15.0615C19.4487 14.5739 20.11 14.3 20.7996 14.3C21.4892 14.3 22.1505 14.5739 22.6381 15.0615C23.1257 15.5491 23.3996 16.2104 23.3996 16.9C23.3996 17.5895 23.1257 18.2508 22.6381 18.7384C22.1505 19.226 21.4892 19.5 20.7996 19.5C20.11 19.5 19.4487 19.226 18.9611 18.7384C18.4735 18.2508 18.1996 17.5895 18.1996 16.9ZM27.2996 6.49995C27.2996 6.15517 27.1626 5.82451 26.9188 5.58071C26.675 5.33692 26.3444 5.19995 25.9996 5.19995C25.6548 5.19995 25.3242 5.33692 25.0804 5.58071C24.8366 5.82451 24.6996 6.15517 24.6996 6.49995V7.79995H16.8996C15.8653 7.79995 14.8733 8.21084 14.1419 8.94223C13.4105 9.67363 12.9996 10.6656 12.9996 11.7V22.1C12.9996 23.1343 13.4105 24.1263 14.1419 24.8577C14.8733 25.5891 15.8653 26 16.8996 26H33.264L34.1116 23.4H16.8996C16.5548 23.4 16.2242 23.263 15.9804 23.0192C15.7366 22.7754 15.5996 22.4447 15.5996 22.1V11.7C15.5996 11.3552 15.7366 11.0245 15.9804 10.7807C16.2242 10.5369 16.5548 10.4 16.8996 10.4H35.0996C35.4444 10.4 35.775 10.5369 36.0188 10.7807C36.2626 11.0245 36.3996 11.3552 36.3996 11.7V21.0158C37.2426 20.7139 38.1667 20.7286 38.9996 21.0574V11.7C38.9996 10.6656 38.5887 9.67363 37.8573 8.94223C37.1259 8.21084 36.134 7.79995 35.0996 7.79995H27.2996V6.49995ZM22.0996 29.9H27.0604C26.3801 30.5911 25.999 31.5223 25.9996 32.4921V32.5078H13.8056C13.2471 32.5078 12.7114 32.7296 12.3164 33.1246C11.9215 33.5195 11.6996 34.0552 11.6996 34.6137V35.75C11.6996 37.5439 12.0402 39.5356 13.7848 41.1294C15.5736 42.7596 19.0836 44.1999 25.9996 44.1999C30.0296 44.1999 32.9026 43.7112 34.954 42.978C35.4236 43.5042 36.0361 43.8827 36.7168 44.0673C36.5492 44.427 36.4462 44.8134 36.4126 45.2088C34.031 46.163 30.8564 46.7427 26.6496 46.7947V46.7999H25.3496V46.7947C18.548 46.7089 14.4426 45.2478 12.0324 43.0508C9.75741 40.9708 9.20101 38.4305 9.11261 36.4051H9.09961V34.6112C9.09961 32.0138 11.2056 29.9078 13.8056 29.9078H22.0996V29.9ZM38.6824 24.1331L39.5872 26.9177C39.8681 27.765 40.3433 28.5348 40.9749 29.1655C41.6065 29.7962 42.377 30.2703 43.2246 30.55L46.0092 31.4547L46.0638 31.4704C46.2786 31.546 46.4646 31.6864 46.5962 31.8722C46.7277 32.058 46.7984 32.2801 46.7984 32.5078C46.7984 32.7354 46.7277 32.9575 46.5962 33.1433C46.4646 33.3291 46.2786 33.4695 46.0638 33.5452L43.2792 34.45C42.4316 34.7296 41.6611 35.2037 41.0295 35.8344C40.3979 36.4651 39.9227 37.2349 39.6418 38.0822L38.737 40.8641C38.6614 41.0789 38.521 41.2649 38.3352 41.3965C38.1494 41.5281 37.9273 41.5988 37.6996 41.5988C37.4719 41.5988 37.2498 41.5281 37.064 41.3965C36.8782 41.2649 36.7378 41.0789 36.6622 40.8641L35.7548 38.0822C35.4318 37.098 34.8477 36.2201 34.0648 35.542C33.4958 35.0483 32.8349 34.6719 32.12 34.4344L29.3354 33.5295C29.1206 33.4539 28.9346 33.3135 28.803 33.1277C28.6715 32.9419 28.6008 32.7198 28.6008 32.4921C28.6008 32.2645 28.6715 32.0424 28.803 31.8566C28.9346 31.6708 29.1206 31.5304 29.3354 31.4547L32.12 30.55C32.9571 30.2627 33.7161 29.7852 34.3373 29.155C34.9586 28.5247 35.4251 27.7589 35.7002 26.9177L36.605 24.1358C36.6801 23.9201 36.8204 23.7331 37.0065 23.6008C37.1926 23.4685 37.4153 23.3974 37.6437 23.3974C37.8721 23.3974 38.0948 23.4685 38.2809 23.6008C38.467 23.7331 38.6074 23.9201 38.6824 24.1358M51.4354 44.7564L49.4438 44.1115C48.8398 43.9098 48.2909 43.5703 47.8406 43.12C47.3902 42.6697 47.0508 42.1208 46.849 41.5168L46.199 39.5278C46.1452 39.3742 46.045 39.2411 45.9122 39.147C45.7795 39.0528 45.6207 39.0023 45.458 39.0023C45.2953 39.0023 45.1366 39.0528 45.0038 39.147C44.8711 39.2411 44.7708 39.3742 44.717 39.5278L44.0722 41.5168C43.8741 42.1169 43.5402 42.6633 43.0965 43.1133C42.6527 43.5634 42.1111 43.905 41.5138 44.1115L39.5248 44.7564C39.4103 44.7971 39.3069 44.8638 39.2225 44.9512C39.138 45.0386 39.075 45.1443 39.0382 45.2602C39.0015 45.376 38.992 45.4987 39.0106 45.6188C39.0291 45.7389 39.0752 45.853 39.1452 45.9523C39.2388 46.0823 39.3714 46.1864 39.5248 46.2384L41.5138 46.8858C42.1199 47.0879 42.6705 47.4286 43.1219 47.8809C43.5732 48.3331 43.9129 48.8844 44.1138 49.4909L44.7586 51.4773C44.8124 51.6309 44.9127 51.764 45.0454 51.8581C45.1781 51.9523 45.3369 52.0028 45.4996 52.0028C45.6623 52.0028 45.8211 51.9523 45.9538 51.8581C46.0866 51.764 46.1868 51.6309 46.2406 51.4773L46.888 49.4909C47.0897 48.8861 47.4294 48.3366 47.8802 47.8858C48.331 47.4349 48.8806 47.0952 49.4854 46.8935L51.4744 46.2487C51.628 46.1949 51.761 46.0947 51.8552 45.962C51.9493 45.8292 51.9999 45.6705 51.9999 45.5078C51.9999 45.345 51.9493 45.1863 51.8552 45.0535C51.761 44.9208 51.628 44.8206 51.4744 44.7668L51.4354 44.7564Z"
        fill="#242424"
      />
    </g>
    <defs>
      <clipPath id="clip0_9004_3577">
        <rect width="52" height="52" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const RegenerateThemeAction = ({ color = '#242424' }: IconProps) => (
  <svg
    width="52"
    height="52"
    viewBox="0 0 52 52"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_12481_4148)">
      <mask
        id="mask0_12481_4148"
        style={{ maskType: 'luminance' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="52"
        height="52"
      >
        <path d="M52 0H0V52H52V0Z" fill="white" />
      </mask>
      <g mask="url(#mask0_12481_4148)">
        <path
          d="M31.1996 14.3002C30.51 14.3002 29.8487 14.5741 29.3611 15.0617C28.8735 15.5493 28.5996 16.2106 28.5996 16.9002C28.5996 17.5897 28.8735 18.251 29.3611 18.7386C29.8487 19.2262 30.51 19.5002 31.1996 19.5002C31.8892 19.5002 32.5505 19.2262 33.0381 18.7386C33.5257 18.251 33.7996 17.5897 33.7996 16.9002C33.7996 16.2106 33.5257 15.5493 33.0381 15.0617C32.5505 14.5741 31.8892 14.3002 31.1996 14.3002ZM18.1996 16.9002C18.1996 16.2106 18.4735 15.5493 18.9611 15.0617C19.4487 14.5741 20.11 14.3002 20.7996 14.3002C21.4892 14.3002 22.1505 14.5741 22.6381 15.0617C23.1257 15.5493 23.3996 16.2106 23.3996 16.9002C23.3996 17.5897 23.1257 18.251 22.6381 18.7386C22.1505 19.2262 21.4892 19.5002 20.7996 19.5002C20.11 19.5002 19.4487 19.2262 18.9611 18.7386C18.4735 18.251 18.1996 17.5897 18.1996 16.9002ZM27.2996 6.5002C27.2996 6.15542 27.1626 5.82476 26.9188 5.58096C26.675 5.33717 26.3444 5.2002 25.9996 5.2002C25.6548 5.2002 25.3242 5.33717 25.0804 5.58096C24.8366 5.82476 24.6996 6.15542 24.6996 6.5002V7.8002H16.8996C15.8653 7.8002 14.8733 8.21109 14.1419 8.94248C13.4105 9.67388 12.9996 10.6658 12.9996 11.7002V22.1002C12.9996 23.1345 13.4105 24.1265 14.1419 24.8579C14.8733 25.5893 15.8653 26.0002 16.8996 26.0002H33.264L34.1116 23.4002H16.8996C16.5548 23.4002 16.2242 23.2632 15.9804 23.0194C15.7366 22.7756 15.5996 22.4449 15.5996 22.1002V11.7002C15.5996 11.3554 15.7366 11.0247 15.9804 10.7809C16.2242 10.5371 16.5548 10.4002 16.8996 10.4002H35.0996C35.4444 10.4002 35.775 10.5371 36.0188 10.7809C36.2626 11.0247 36.3996 11.3554 36.3996 11.7002V21.016C37.2426 20.7141 38.1667 20.7288 38.9996 21.0576V11.7002C38.9996 10.6658 38.5887 9.67388 37.8573 8.94248C37.1259 8.21109 36.134 7.8002 35.0996 7.8002H27.2996V6.5002ZM22.0996 29.9002H27.0604C26.3801 30.5913 25.999 31.5225 25.9996 32.4923V32.508H13.8056C13.2471 32.508 12.7114 32.7298 12.3164 33.1248C11.9215 33.5197 11.6996 34.0554 11.6996 34.6139V35.7502C11.6996 37.5441 12.0402 39.5358 13.7848 41.1296C15.5736 42.7598 19.0836 44.2001 25.9996 44.2001C30.0296 44.2001 32.9026 43.7114 34.954 42.9782C35.4236 43.5044 36.0361 43.8829 36.7168 44.0675C36.5492 44.4272 36.4462 44.8136 36.4126 45.209C34.031 46.1632 30.8564 46.7429 26.6496 46.7949V46.8001H25.3496V46.7949C18.548 46.7091 14.4426 45.248 12.0324 43.051C9.75741 40.971 9.20101 38.4307 9.11261 36.4053H9.09961V34.6114C9.09961 32.014 11.2056 29.908 13.8056 29.908H22.0996V29.9002Z"
          fill="#242424"
        />
      </g>
      <g clip-path="url(#clip1_12481_4148)">
        <path
          d="M44.9384 39.9363C43.8799 40.5015 42.6984 40.797 41.4984 40.7965C40.2985 40.796 39.1172 40.4996 38.0592 39.9336C37.0012 39.3675 36.0991 38.5492 35.4328 37.5513C34.7666 36.5533 34.3567 35.4064 34.2396 34.2122C34.1225 33.018 34.3016 31.8134 34.7613 30.705C35.2209 29.5965 35.9468 28.6186 36.8746 27.8577C37.8025 27.0969 38.9037 26.5766 40.0806 26.3429C41.2576 26.1093 42.474 26.1695 43.6221 26.5183C46.7701 27.4746 48.0409 30.1526 49.3076 32.9057"
          stroke="#242424"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M50.2494 29.803L49.3068 32.9059L46.2039 31.9633"
          stroke="#242424"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_12481_4148">
        <rect width="52" height="52" fill="white" />
      </clipPath>
      <clipPath id="clip1_12481_4148">
        <rect
          width="19.4576"
          height="19.4576"
          fill="white"
          transform="translate(35.0195 21.3633) rotate(16.8976)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const AddThemeAction = ({ color = '#242424' }: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="52"
    height="52"
    viewBox="0 0 52 52"
    fill="none"
  >
    <path
      d="M37.9165 25.9999C41.077 25.9999 44.108 27.2554 46.3428 29.4902C48.5776 31.725 49.8331 34.7561 49.8331 37.9166C49.8331 41.0771 48.5776 44.1081 46.3428 46.3429C44.108 48.5778 41.077 49.8333 37.9165 49.8333C34.756 49.8333 31.7249 48.5778 29.4901 46.3429C27.2553 44.1081 25.9998 41.0771 25.9998 37.9166C25.9998 34.7561 27.2553 31.725 29.4901 29.4902C31.7249 27.2554 34.756 25.9999 37.9165 25.9999ZM26.0496 30.3311C25.4008 31.3444 24.8846 32.4366 24.5135 33.5811H9.2168C8.78582 33.5811 8.37249 33.7523 8.06775 34.057C7.763 34.3618 7.5918 34.7751 7.5918 35.2061V37.1734C7.5918 38.5926 8.21146 39.9424 9.2883 40.8698C12.014 43.2141 16.122 44.4166 21.6665 44.4166C22.9665 44.4166 24.1856 44.3509 25.3238 44.2194C25.8655 45.3028 26.5436 46.3059 27.3388 47.2094C25.5982 47.5142 23.7075 47.6666 21.6665 47.6666C15.4048 47.6666 10.5558 46.2453 7.17146 43.3333C6.28413 42.5708 5.57193 41.6257 5.08356 40.5625C4.59519 39.4994 4.34217 38.3434 4.3418 37.1734V35.2061C4.34237 33.9135 4.85624 32.6741 5.77042 31.7603C6.68459 30.8466 7.92424 30.3333 9.2168 30.3333L26.0496 30.3311ZM37.9165 30.3311L37.7215 30.3484C37.505 30.388 37.3057 30.4925 37.1501 30.6481C36.9945 30.8037 36.89 31.003 36.8505 31.2194L36.8331 31.4144V36.8311H31.4121L31.2171 36.8506C31.0007 36.8901 30.8014 36.9947 30.6458 37.1502C30.4902 37.3058 30.3857 37.5051 30.3461 37.7216L30.3288 37.9166L30.3461 38.1116C30.3861 38.3277 30.4908 38.5265 30.6463 38.6816C30.8019 38.8368 31.001 38.941 31.2171 38.9804L31.4121 38.9999L36.8353 38.9978V44.4231L36.8526 44.6181C36.8923 44.8348 36.9972 45.0343 37.1532 45.19C37.3092 45.3456 37.5089 45.4499 37.7258 45.4891L37.9208 45.5064L38.1158 45.4891C38.3319 45.4491 38.5307 45.3444 38.6858 45.1889C38.841 45.0333 38.9452 44.8343 38.9846 44.6181L39.0041 44.4231L38.9998 38.9978H44.4251L44.6201 38.9804C44.8366 38.9409 45.0359 38.8364 45.1915 38.6808C45.3471 38.5252 45.4516 38.3259 45.4911 38.1094L45.5085 37.9144L45.4911 37.7194C45.4512 37.5034 45.3465 37.3045 45.1909 37.1494C45.0354 36.9942 44.8363 36.89 44.6201 36.8506L44.4251 36.8333L38.9998 36.8311V31.4144L38.9825 31.2194C38.9429 31.003 38.8384 30.8037 38.6828 30.6481C38.5272 30.4925 38.3279 30.388 38.1115 30.3484L37.9165 30.3311ZM21.6665 4.33325C22.0595 4.33275 22.4394 4.47472 22.7358 4.73287C23.0322 4.99102 23.225 5.34785 23.2785 5.73725L23.2936 5.95825L23.2915 7.58109H30.8748C32.1677 7.58109 33.4077 8.0947 34.3219 9.00894C35.2362 9.92318 35.7498 11.1632 35.7498 12.4561V22.2169C35.7498 22.8691 35.622 23.4931 35.3901 24.0608C33.0021 24.4926 30.7674 25.5379 28.9053 27.0941H12.4603C11.1674 27.0941 9.92739 26.5805 9.01315 25.6662C8.09891 24.752 7.5853 23.512 7.5853 22.2191V12.4583C7.5853 11.1657 8.09861 9.92605 9.01238 9.01187C9.92616 8.0977 11.1656 7.58383 12.4581 7.58325L20.0393 7.58109V5.95825C20.0394 5.60246 20.1562 5.25651 20.3718 4.97353C20.5875 4.69054 20.8901 4.48616 21.2331 4.39175L21.4455 4.34842L21.6665 4.33325ZM30.8748 10.8333H12.4581C12.0272 10.8333 11.6138 11.0045 11.3091 11.3092C11.0043 11.614 10.8331 12.0273 10.8331 12.4583V22.2169C10.8331 23.1139 11.5611 23.8419 12.4581 23.8419H30.8748C31.3058 23.8419 31.7191 23.6707 32.0238 23.366C32.3286 23.0612 32.4998 22.6479 32.4998 22.2169V12.4583C32.4998 12.0273 32.3286 11.614 32.0238 11.3092C31.7191 11.0045 31.3058 10.8333 30.8748 10.8333ZM16.7915 14.0833C17.156 14.0687 17.5196 14.1279 17.8607 14.2573C18.2017 14.3867 18.5131 14.5837 18.7762 14.8364C19.0392 15.0891 19.2485 15.3924 19.3915 15.728C19.5344 16.0636 19.6081 16.4246 19.6081 16.7894C19.6081 17.1542 19.5344 17.5152 19.3915 17.8508C19.2485 18.1864 19.0392 18.4897 18.7762 18.7424C18.5131 18.9951 18.2017 19.1921 17.8607 19.3216C17.5196 19.451 17.156 19.5102 16.7915 19.4956C16.0925 19.4676 15.4314 19.1703 14.9468 18.6658C14.4621 18.1614 14.1914 17.489 14.1914 16.7894C14.1914 16.0899 14.4621 15.4175 14.9468 14.913C15.4314 14.4086 16.0925 14.1112 16.7915 14.0833ZM26.5241 14.0833C26.8886 14.0687 27.2523 14.1279 27.5933 14.2573C27.9344 14.3867 28.2458 14.5837 28.5088 14.8364C28.7719 15.0891 28.9812 15.3924 29.1241 15.728C29.2671 16.0636 29.3408 16.4246 29.3408 16.7894C29.3408 17.1542 29.2671 17.5152 29.1241 17.8508C28.9812 18.1864 28.7719 18.4897 28.5088 18.7424C28.2458 18.9951 27.9344 19.1921 27.5933 19.3216C27.2523 19.451 26.8886 19.5102 26.5241 19.4956C25.8251 19.4676 25.1641 19.1703 24.6794 18.6658C24.1948 18.1614 23.9241 17.489 23.9241 16.7894C23.9241 16.0899 24.1948 15.4175 24.6794 14.913C25.1641 14.4086 25.8251 14.1112 26.5241 14.0833Z"
      fill="#242424"
    />
  </svg>
);

export const AddSectionIcon = ({ color = '#242424' }: IconProps) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3 4.5H13C13.5304 4.5 14.0391 4.71071 14.4142 5.08579C14.7893 5.46086 15 5.96957 15 6.5V9.5C15 10.0304 14.7893 10.5391 14.4142 10.9142C14.0391 11.2893 13.5304 11.5 13 11.5H3C2.46957 11.5 1.96086 11.2893 1.58579 10.9142C1.21071 10.5391 1 10.0304 1 9.5V6.5C1 5.96957 1.21071 5.46086 1.58579 5.08579C1.96086 4.71071 2.46957 4.5 3 4.5ZM3 5.5C2.73478 5.5 2.48043 5.60536 2.29289 5.79289C2.10536 5.98043 2 6.23478 2 6.5V9.5C2 9.76522 2.10536 10.0196 2.29289 10.2071C2.48043 10.3946 2.73478 10.5 3 10.5H13C13.2652 10.5 13.5196 10.3946 13.7071 10.2071C13.8946 10.0196 14 9.76522 14 9.5V6.5C14 6.23478 13.8946 5.98043 13.7071 5.79289C13.5196 5.60536 13.2652 5.5 13 5.5H3ZM1 2C1 1.86739 1.05268 1.74021 1.14645 1.64645C1.24021 1.55268 1.36739 1.5 1.5 1.5H14.5C14.6326 1.5 14.7598 1.55268 14.8536 1.64645C14.9473 1.74021 15 1.86739 15 2C15 2.13261 14.9473 2.25979 14.8536 2.35355C14.7598 2.44732 14.6326 2.5 14.5 2.5H1.5C1.36739 2.5 1.24021 2.44732 1.14645 2.35355C1.05268 2.25979 1 2.13261 1 2ZM1 14C1 13.8674 1.05268 13.7402 1.14645 13.6464C1.24021 13.5527 1.36739 13.5 1.5 13.5H14.5C14.6326 13.5 14.7598 13.5527 14.8536 13.6464C14.9473 13.7402 15 13.8674 15 14C15 14.1326 14.9473 14.2598 14.8536 14.3536C14.7598 14.4473 14.6326 14.5 14.5 14.5H1.5C1.36739 14.5 1.24021 14.4473 1.14645 14.3536C1.05268 14.2598 1 14.1326 1 14Z"
      fill="#5579F2"
    />
  </svg>
);

export const ThemeLibraryIcon = ({
  color = '#242424',
  size = '20',
}: IconProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19.5623 7C19.616 6.69354 19.6019 6.37903 19.5212 6.07857C19.4404 5.7781 19.2949 5.49895 19.0947 5.26071C18.8946 5.02248 18.6448 4.83093 18.3628 4.69951C18.0807 4.5681 17.7734 4.5 17.4622 4.5H6.53825C6.22712 4.5 5.91975 4.5681 5.63774 4.69951C5.35572 4.83093 5.10589 5.02248 4.90577 5.26071C4.70565 5.49895 4.5601 5.7781 4.47933 6.07857C4.39857 6.37903 4.38455 6.69354 4.43825 7M17.5002 4.5C17.5282 4.24 17.5432 4.111 17.5432 4.004C17.5443 3.50969 17.3623 3.0325 17.0323 2.66446C16.7023 2.29643 16.2477 2.06364 15.7562 2.011C15.6502 2 15.5203 2 15.2603 2H8.74025C8.48025 2 8.34925 2 8.24325 2.011C7.75175 2.06364 7.29716 2.29643 6.96717 2.66446C6.63718 3.0325 6.45517 3.50969 6.45625 4.004C6.45625 4.111 6.47025 4.241 6.49925 4.5"
      stroke={color}
      stroke-width="1.5"
    />
    <path
      d="M15.0003 18H9.00033M21.1943 16.793C20.8443 19.273 20.6693 20.514 19.7723 21.257C18.8753 22 17.5523 22 14.9053 22H9.09533C6.44933 22 5.12533 22 4.22833 21.257C3.33133 20.514 3.15633 19.274 2.80633 16.793L2.38433 13.793C1.93733 10.629 1.71433 9.048 2.66233 8.023C3.61033 7 5.29833 7 8.67233 7H15.3283C18.7023 7 20.3903 7 21.3383 8.024C22.0873 8.833 22.1053 9.99 21.8593 12"
      stroke={color}
      stroke-width="1.5"
      stroke-linecap="round"
    />
  </svg>
);

export const ViewSavedFilter = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20.46 17.515C20.82 17.931 21 18.139 21 18.5C21 18.861 20.82 19.07 20.46 19.485C19.56 20.52 17.937 22 16 22C14.063 22 12.439 20.52 11.54 19.485C11.18 19.069 11 18.862 11 18.5C11 18.139 11.18 17.93 11.54 17.515C12.44 16.48 14.063 15 16 15C17.937 15 19.561 16.48 20.46 17.515Z"
      stroke="#5579F2"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M20 13.003V7.82C20 6.126 20 5.28 19.732 4.603C19.302 3.516 18.39 2.658 17.235 2.253C16.517 2 15.617 2 13.818 2C10.67 2 9.096 2 7.838 2.441C5.818 3.151 4.223 4.652 3.468 6.555C3 7.74 3 9.221 3 12.185V14.731C3 17.801 3 19.336 3.848 20.403C4.091 20.708 4.378 20.979 4.703 21.208C5.615 21.851 6.85 21.976 9 22"
      stroke="#5579F2"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M3 12C3 11.116 3.35115 10.2683 3.97621 9.64321C4.60127 9.01815 5.44903 8.667 6.333 8.667C6.999 8.667 7.784 8.783 8.431 8.61C8.71371 8.53392 8.97145 8.38485 9.17838 8.17774C9.38531 7.97064 9.53416 7.71277 9.61 7.43C9.783 6.783 9.667 5.998 9.667 5.332C9.66726 4.44821 10.0185 3.6007 10.6436 2.97586C11.2686 2.35102 12.1162 2 13 2M15.992 18.5H16.002"
      stroke="#5579F2"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const CreateNewReportIcon = ({ color }: IconProps) => (
  <svg
    width="21"
    height="21"
    viewBox="0 0 21 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10 4.5H5.5C4.96957 4.5 4.46086 4.71071 4.08579 5.08579C3.71071 5.46086 3.5 5.96957 3.5 6.5V15.5C3.5 16.0304 3.71071 16.5391 4.08579 16.9142C4.46086 17.2893 4.96957 17.5 5.5 17.5H15.5C16.0304 17.5 16.5391 17.2893 16.9142 16.9142C17.2893 16.5391 17.5 16.0304 17.5 15.5V11"
      stroke={color}
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M15.5 5.49963L16.453 6.49963M17.5 3.46663C17.7666 3.74228 17.9142 4.11164 17.911 4.4951C17.9078 4.87857 17.7541 5.24543 17.483 5.51663L10.5 12.4996L7.5 13.4996L8.5 10.4996L15.487 3.45363C15.7326 3.2061 16.0613 3.05846 16.4095 3.03925C16.7577 3.02004 17.1006 3.13063 17.372 3.34963L17.5 3.46663Z"
      stroke={color}
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const ManageThemeIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8 5H4C3.44772 5 3 5.44772 3 6V10C3 10.5523 3.44772 11 4 11H8C8.55228 11 9 10.5523 9 10V6C9 5.44772 8.55228 5 8 5Z"
      stroke="#5579F2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M3 17L5 19L9 15M13 6H21M13 12H21M13 18H21"
      stroke="#5579F2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const DoneTick = ({ color = '#242424' }: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="97"
    height="133"
    viewBox="0 0 97 133"
    fill="none"
  >
    <path
      d="M21.0924 130.216C19.7644 130.216 18.5484 130.048 17.4444 129.712C16.3404 129.36 15.4044 128.872 14.6364 128.248L15.4284 126.28C16.2284 126.888 17.0844 127.344 17.9964 127.648C18.9084 127.952 19.9404 128.104 21.0924 128.104C22.4524 128.104 23.4524 127.864 24.0924 127.384C24.7484 126.888 25.0764 126.248 25.0764 125.464C25.0764 124.824 24.8444 124.32 24.3804 123.952C23.9164 123.568 23.1404 123.264 22.0524 123.04L19.4844 122.512C17.9644 122.192 16.8284 121.664 16.0764 120.928C15.3404 120.192 14.9724 119.2 14.9724 117.952C14.9724 116.944 15.2364 116.056 15.7644 115.288C16.3084 114.52 17.0604 113.928 18.0204 113.512C18.9804 113.08 20.0844 112.864 21.3324 112.864C22.4844 112.864 23.5484 113.04 24.5244 113.392C25.5164 113.728 26.3564 114.224 27.0444 114.88L26.2284 116.776C24.8684 115.576 23.2284 114.976 21.3084 114.976C20.1244 114.976 19.1804 115.24 18.4764 115.768C17.7884 116.296 17.4444 117 17.4444 117.88C17.4444 118.552 17.6604 119.088 18.0924 119.488C18.5244 119.888 19.2444 120.192 20.2524 120.4L22.7964 120.928C24.3964 121.264 25.5884 121.784 26.3724 122.488C27.1564 123.176 27.5484 124.112 27.5484 125.296C27.5484 126.288 27.2844 127.152 26.7564 127.888C26.2284 128.624 25.4844 129.2 24.5244 129.616C23.5644 130.016 22.4204 130.216 21.0924 130.216ZM33.8621 130.216C33.0461 130.216 32.3181 130.056 31.6781 129.736C31.0381 129.416 30.5261 128.984 30.1421 128.44C29.7741 127.896 29.5901 127.28 29.5901 126.592C29.5901 125.728 29.8061 125.048 30.2381 124.552C30.6861 124.056 31.4141 123.696 32.4221 123.472C33.4461 123.248 34.8221 123.136 36.5501 123.136H37.3661V122.512C37.3661 121.6 37.1741 120.944 36.7901 120.544C36.4061 120.144 35.7741 119.944 34.8941 119.944C34.2221 119.944 33.5501 120.048 32.8781 120.256C32.2061 120.448 31.5181 120.76 30.8141 121.192L30.0701 119.488C30.6781 119.056 31.4381 118.712 32.3501 118.456C33.2621 118.2 34.1341 118.072 34.9661 118.072C36.5661 118.072 37.7501 118.456 38.5181 119.224C39.2861 119.976 39.6701 121.16 39.6701 122.776V130H37.3901V128.056C37.1021 128.728 36.6541 129.256 36.0461 129.64C35.4381 130.024 34.7101 130.216 33.8621 130.216ZM34.3421 128.488C35.2061 128.488 35.9261 128.184 36.5021 127.576C37.0781 126.968 37.3661 126.2 37.3661 125.272V124.624H36.5741C35.4061 124.624 34.4861 124.68 33.8141 124.792C33.1581 124.904 32.6861 125.096 32.3981 125.368C32.1261 125.624 31.9901 125.984 31.9901 126.448C31.9901 127.056 32.1981 127.552 32.6141 127.936C33.0301 128.304 33.6061 128.488 34.3421 128.488ZM46.3235 130L41.2835 118.288H43.8995L47.4755 127.192L51.1475 118.288H53.6195L48.5075 130H46.3235ZM60.6453 130.216C58.7253 130.216 57.2133 129.68 56.1093 128.608C55.0053 127.52 54.4533 126.04 54.4533 124.168C54.4533 122.968 54.6933 121.912 55.1733 121C55.6693 120.072 56.3493 119.352 57.2133 118.84C58.0773 118.328 59.0693 118.072 60.1893 118.072C61.8053 118.072 63.0773 118.592 64.0053 119.632C64.9333 120.656 65.3973 122.072 65.3973 123.88V124.696H56.8053C56.9813 127.128 58.2693 128.344 60.6693 128.344C61.3413 128.344 61.9973 128.24 62.6373 128.032C63.2933 127.824 63.9093 127.48 64.4853 127L65.2053 128.68C64.6773 129.16 63.9973 129.536 63.1653 129.808C62.3333 130.08 61.4933 130.216 60.6453 130.216ZM60.2853 119.776C59.2773 119.776 58.4773 120.088 57.8853 120.712C57.2933 121.336 56.9333 122.168 56.8053 123.208H63.3573C63.3093 122.12 63.0213 121.28 62.4933 120.688C61.9653 120.08 61.2293 119.776 60.2853 119.776ZM72.5039 130.216C71.4799 130.216 70.5759 129.976 69.7919 129.496C69.0239 129 68.4239 128.296 67.9919 127.384C67.5599 126.472 67.3439 125.392 67.3439 124.144C67.3439 122.896 67.5599 121.824 67.9919 120.928C68.4239 120.016 69.0239 119.312 69.7919 118.816C70.5599 118.32 71.4639 118.072 72.5039 118.072C73.3839 118.072 74.1679 118.264 74.8559 118.648C75.5439 119.032 76.0559 119.552 76.3919 120.208V113.08H78.8159V130H76.4399V127.96C76.1039 128.664 75.5839 129.216 74.8799 129.616C74.1919 130.016 73.3999 130.216 72.5039 130.216ZM73.1279 128.344C74.1199 128.344 74.9199 127.984 75.5279 127.264C76.1359 126.544 76.4399 125.504 76.4399 124.144C76.4399 122.784 76.1359 121.752 75.5279 121.048C74.9199 120.328 74.1199 119.968 73.1279 119.968C72.1199 119.968 71.3119 120.328 70.7039 121.048C70.0959 121.752 69.7919 122.784 69.7919 124.144C69.7919 125.504 70.0959 126.544 70.7039 127.264C71.3119 127.984 72.1199 128.344 73.1279 128.344Z"
      fill="white"
    />
    <path
      d="M47.6667 95.3333C73.9922 95.3333 95.3333 73.9922 95.3333 47.6667C95.3333 21.3411 73.9922 0 47.6667 0C21.3411 0 0 21.3411 0 47.6667C0 73.9922 21.3411 95.3333 47.6667 95.3333Z"
      fill="#4B9D70"
      fill-opacity="0.4"
    />
    <path
      d="M26.8125 41.7087L44.0559 58.9521C44.2235 59.1194 44.4507 59.2135 44.6875 59.2135C44.9243 59.2135 45.1515 59.1194 45.3191 58.9521L92.3542 11.917"
      stroke="#14C162"
      stroke-width="11"
    />
  </svg>
);

export const ReRunQueryIcon = ({
  color = '#242424',
  size = '24',
}: IconProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.29529 8.37231C4.5145 8.37231 4.72473 8.4594 4.87974 8.6144C5.03474 8.76941 5.12182 8.97964 5.12182 9.19885V10.0254C5.12182 11.3407 5.64431 12.6021 6.57435 13.5321C7.50438 14.4621 8.76578 14.9846 10.081 14.9846H13.045L12.3896 14.3292C12.239 14.1733 12.1557 13.9645 12.1576 13.7478C12.1595 13.5311 12.2464 13.3238 12.3996 13.1705C12.5529 13.0173 12.7602 12.9303 12.9769 12.9285C13.1936 12.9266 13.4024 13.0099 13.5583 13.1604L15.6246 15.2268C15.7489 15.3511 15.8302 15.5118 15.8569 15.6855L15.8668 15.8194C15.8646 16.0374 15.7763 16.2456 15.6213 16.3988L13.5583 18.4619C13.4024 18.6124 13.1936 18.6957 12.9769 18.6938C12.7602 18.692 12.5529 18.605 12.3996 18.4518C12.2464 18.2985 12.1595 18.0912 12.1576 17.8745C12.1557 17.6578 12.239 17.449 12.3896 17.2931L13.045 16.6377H10.081C8.32736 16.6377 6.64549 15.941 5.40545 14.701C4.1654 13.4609 3.46875 11.7791 3.46875 10.0254V9.19885C3.46875 8.97964 3.55583 8.76941 3.71084 8.6144C3.86584 8.4594 4.07608 8.37231 4.29529 8.37231ZM16.6933 6.71924C16.848 6.71924 16.9995 6.76261 17.1307 6.84444C17.2619 6.92626 17.3675 7.04324 17.4356 7.1821L17.4752 7.27881L17.5827 7.59124C17.6961 7.92366 17.8788 8.22819 18.1188 8.48467C18.3587 8.74116 18.6504 8.94374 18.9746 9.079L19.1275 9.13686L19.4399 9.24348C19.5946 9.29627 19.7302 9.39375 19.8296 9.52359C19.9289 9.65344 19.9875 9.80982 19.9979 9.97297C20.0083 10.1361 19.9702 10.2987 19.8882 10.4401C19.8062 10.5816 19.6842 10.6955 19.5375 10.7676L19.4399 10.8073L19.1275 10.9147C18.7951 11.0281 18.4905 11.2109 18.2341 11.4508C17.9776 11.6908 17.775 11.9825 17.6397 12.3066L17.5819 12.4595L17.4752 12.772C17.4225 12.9267 17.325 13.0623 17.1951 13.1616C17.0653 13.2609 16.9089 13.3195 16.7458 13.3299C16.5826 13.3404 16.42 13.3022 16.2786 13.2203C16.1372 13.1383 16.0232 13.0162 15.9511 12.8695L15.9114 12.772L15.804 12.4595C15.6906 12.1271 15.5079 11.8226 15.2679 11.5661C15.0279 11.3096 14.7362 11.107 14.4121 10.9718L14.2592 10.9139L13.9468 10.8073C13.792 10.7545 13.6564 10.657 13.5571 10.5272C13.4578 10.3973 13.3992 10.241 13.3888 10.0778C13.3783 9.91467 13.4165 9.75209 13.4985 9.61065C13.5804 9.4692 13.7025 9.35523 13.8492 9.28316L13.9468 9.24348L14.2592 9.13603C14.5916 9.02263 14.8961 8.8399 15.1526 8.59995C15.4091 8.35999 15.6117 8.06829 15.747 7.74415L15.8048 7.59124L15.9114 7.27881C15.9671 7.11564 16.0724 6.97397 16.2127 6.87363C16.3529 6.77329 16.5209 6.71931 16.6933 6.71924ZM16.6933 9.36085C16.4978 9.60691 16.2749 9.82986 16.0288 10.0254C16.2757 10.221 16.4972 10.4425 16.6933 10.6899C16.889 10.4425 17.1105 10.221 17.3579 10.0254C17.1118 9.82986 16.8889 9.60691 16.6933 9.36085ZM9.4256 3.242C9.58055 3.397 9.6676 3.60719 9.6676 3.82636C9.6676 4.04553 9.58055 4.25572 9.4256 4.41072L8.77016 5.06617H11.7341C12.7466 5.06617 13.7087 5.29429 14.5691 5.7026C14.6672 5.74927 14.7551 5.8148 14.8279 5.89545C14.9006 5.9761 14.9568 6.07029 14.9931 6.17264C15.0294 6.27499 15.0453 6.38349 15.0397 6.49195C15.0341 6.60042 15.0072 6.70672 14.9605 6.80479C14.9138 6.90285 14.8483 6.99077 14.7677 7.06351C14.687 7.13625 14.5928 7.1924 14.4905 7.22874C14.2838 7.30213 14.0564 7.29041 13.8583 7.19615C13.1943 6.88181 12.4688 6.71891 11.7341 6.71924H8.77016L9.4256 7.37468C9.57616 7.53057 9.65947 7.73936 9.65759 7.95607C9.65571 8.17279 9.56878 8.38009 9.41553 8.53334C9.26229 8.68659 9.05498 8.77351 8.83827 8.77539C8.62155 8.77728 8.41277 8.69397 8.25688 8.54341L6.19054 6.47706C6.03558 6.32207 5.94854 6.11187 5.94854 5.8927C5.94854 5.67353 6.03558 5.46334 6.19054 5.30834L8.25688 3.242C8.41188 3.08705 8.62207 3 8.84124 3C9.06041 3 9.2706 3.08705 9.4256 3.242Z"
      fill={color}
    />
  </svg>
);
